<template>
  <div class="COMPNAME">

  </div>
</template>

<script>

export default {
  name: 'Setting',
  components: {

  },
  props: [

  ],
  data() {
    return {
    };
  },
  methods: {

  },
  computed: {

  },
  created() {

  },
  watch: {

  }
};

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Setting.vue